import { DocumentDuplicateIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'

import { pv } from '../motion'
import { AnalysisScreen, Panel } from '../v3/panels'
import { inB } from './beats'
import { fade } from './figures'

/**
 * Produkt-Elemente der Version 10, die es in v3 und v9 noch nicht gibt.
 * Zahlen sind Beispielwerte.
 */

// ---------- Anforderungsanalyse durch das Team ----------

const EXPERTS = [
  { who: 'Tina · Teamleitung', q: 'Wie wichtig ist Emotionswahrnehmung?' },
  { who: 'Kai · Customer Success', q: 'Wie wichtig ist Teamarbeit?' },
  { who: 'Elif · Customer Success', q: 'Wie wichtig ist Gewissenhaftigkeit?' }
]

export function AnalysisStack() {
  return (
    <div className='v9-analysis v10-analysis'>
      {EXPERTS.map((e, i) => (
        <div key={e.who} className='v9-analysis__item'>
          <span className='v9-analysis__who'>{e.who}</span>
          <AnalysisScreen delay={i * 0.04} question={e.q} />
        </div>
      ))}
    </div>
  )
}

// ---------- Ein Jahr später: Anforderungen 2025 und 2026 ----------

const ROWS = [
  { name: 'Emotionswahrnehmung', a: [60, 85], b: [60, 86], trend: 'same' },
  { name: 'Problemlösefähigkeit', a: [38, 60], b: [58, 84], trend: 'up' },
  { name: 'Offenheit für Neues', a: [34, 58], b: [56, 82], trend: 'up' },
  { name: 'Merkfähigkeit', a: [56, 82], b: [38, 64], trend: 'down' }
]
const TREND = { up: '↑ wichtiger', down: '↓ weniger wichtig', same: 'gleich' }

const TEAM = [
  { name: 'Lena', text: 'Passt weiter', tone: 'green' },
  { name: 'Kai', text: 'Schulung anbieten', tone: 'yellow' },
  { name: 'Noah', text: 'Gespräch führen', tone: 'pink' }
]

// Ideal- und Übergangsbereich wandern mit --m von 2025 nach 2026
const moving = ([a0, a1], [b0, b1], pad = 0) => ({
  left: `calc(${a0 - pad}% + ${b0 - a0}% * var(--m))`,
  width: `calc(${a1 - a0 + 2 * pad}% + ${b1 - a1 - (b0 - a0)}% * var(--m))`
})

const w = (a, z) => inB('wachsen', a, z)

export function GrowthMock() {
  return (
    <Panel
      at={w(0.3, 0.4)}
      out={w(0.92, 1)}
      className='off-doc kx-wandel v10-growth'
    >
      <div className='kx-wandel__head'>
        <div>
          <div className='off-doc__eyebrow'>Anforderungsprofil</div>
          <div className='off-doc__title'>Customer Success Manager:in</div>
        </div>
        <div className='kx-years'>
          <span>
            <b>2025</b>
            <i style={fade([-1, 0], w(0.46, 0.5))}>2025</i>
          </span>
          <span>
            <b>2026</b>
            <i style={fade(w(0.46, 0.5))}>2026</i>
          </span>
        </div>
      </div>
      <div className='kx-copy' style={fade(w(0.4, 0.46))}>
        <DocumentDuplicateIcon width={14} height={14} /> Stelle kopiert,
        Anforderungsanalyse 2026 abgeschlossen
      </div>
      <div style={pv('m', w(0.46, 0.6))}>
        {ROWS.map((r, i) => (
          <div key={r.name} className='kx-row'>
            <i
              className='kx-row__hl'
              style={r.trend === 'same' ? { opacity: 0 } : fade(w(0.6, 0.64))}
            />
            <div className='kx-row__head'>
              <span>{r.name}</span>
              <em
                className={`kx-trend kx-trend--${r.trend}`}
                style={fade(w(0.6 + i * 0.01, 0.64 + i * 0.01))}
              >
                {TREND[r.trend]}
              </em>
            </div>
            <div className='kx-beam'>
              <i className='kx-beam__trans' style={moving(r.a, r.b, 10)} />
              <i className='kx-beam__ideal' style={moving(r.a, r.b)} />
              <i
                className='kx-beam__ghost'
                style={{
                  left: `${r.a[0]}%`,
                  width: `${r.a[1] - r.a[0]}%`,
                  ...fade(w(0.46, 0.5))
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <div className='v10-growth__team'>
        <small style={fade(w(0.66, 0.7))}>Abgleich mit dem Team</small>
        {TEAM.map((m, i) => (
          <span
            key={m.name}
            className={clsx('v10-growth__row', `is-${m.tone}`)}
            style={fade(w(0.68 + i * 0.04, 0.72 + i * 0.04))}
          >
            <b>{m.name}</b>
            {m.text}
          </span>
        ))}
      </div>
    </Panel>
  )
}
